// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation__shadow{pointer-events:none;opacity:1;transition:opacity .32s cubic-bezier(.4,0,.2,1);position:absolute;bottom:0;left:50%;transform:translate(-50%,100%);width:100%;height:20px;overflow:hidden;z-index:1}.header--light:not(.navigation--opened) .navigation__shadow{opacity:0}.navigation__shadow:before{content:\"\";width:100%;height:100%;top:0;transform:translateY(-100%);box-shadow:0 -2px 20px 0 rgba(0,0,0,.1);display:block}", ""]);
// Exports
module.exports = exports;
